(() => {
  'use strict';
  const source = document.getElementById('SpookyGiftConfig');
  const template = document.getElementById('SpookyGiftCartTemplate');
  if (!source || !template) return;
  const config = JSON.parse(source.textContent);
  let timer;
  let sequence = 0;
  let lastCart = null;
  const money = (cents, currency = config.currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency}).format(cents / 100);
  function state(cart) {
    const giftItems = (cart.items || []).filter(item => String(item.variant_id) === String(config.giftVariant));
    const giftTotal = giftItems.reduce((sum,item) => sum + Number(item.final_line_price || 0),0);
    const subtotal = Math.max(0,Number(cart.total_price || 0) - giftTotal);
    const currency = cart.currency || config.currency;
    const supported = currency === 'USD';
    const remaining = Math.max(0,config.threshold - subtotal);
    const hasFreeGift = supported && remaining === 0 && giftItems.some(item => item.quantity > 0 && Number(item.final_line_price) === 0);
    return {supported,subtotal,remaining,hasFreeGift,currency};
  }
  function render(cart) {
    const result = cart ? state(cart) : null;
    document.querySelectorAll('[data-spooky-cart]').forEach(card => {
      const status = card.querySelector('[data-spooky-status]');
      const progress = card.querySelector('[data-spooky-progress]');
      let message = config.strings.generic.replace('[threshold]', money(config.threshold,'USD'));
      if (result?.supported) {
        message = result.hasFreeGift ? config.strings.added : result.remaining === 0 ? config.strings.qualified : config.strings.remaining.replace('[amount]',money(result.remaining,result.currency));
        progress.value = Math.min(100,result.subtotal / config.threshold * 100);
      }
      progress.hidden = !result?.supported;
      if (status.textContent !== message) status.textContent = message;
    });
  }
  function mount() {
    const anchor = document.querySelector('[data-rebuy-cart-anchor="body"]');
    if (anchor && !anchor.querySelector('[data-spooky-cart]')) anchor.prepend(template.content.cloneNode(true));
    if (config.isCartPage) {
      const main = document.getElementById('MainContent');
      if (main && !main.querySelector('[data-spooky-cart]')) main.prepend(template.content.cloneNode(true));
    }
    render(lastCart);
  }
  async function refresh() {
    mount();
    const request = ++sequence;
    try {
      const response = await fetch(config.cartUrl,{headers:{Accept:'application/json'},cache:'no-store'});
      if (!response.ok) return;
      const cart = await response.json();
      if (request !== sequence) return;
      lastCart = cart;
      mount();
    } catch { render(lastCart); }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh,150); }
  ['rebuy:smartcart.ready','rebuy:smartcart.show','rebuy:cart.change','cart:updated','cart:change','shopify:section:load'].forEach(name => document.addEventListener(name,schedule));
  document.addEventListener('visibilitychange',() => { if (!document.hidden) schedule(); });
  document.querySelectorAll('.ams-spooky-promo__video').forEach(details => details.addEventListener('toggle',() => { if (!details.open) details.querySelector('video')?.pause(); }));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',refresh,{once:true}); else refresh();
  let attempts = 0;
  const retry = setInterval(() => { mount(); if (++attempts >= 20 || document.querySelector('[data-rebuy-cart-anchor="body"] [data-spooky-cart]')) clearInterval(retry); },500);
})();

